import { Injectable } from '@angular/core';
import { getAuth } from '@angular/fire/auth';
import { uploadBytesResumable, getDownloadURL, getStorage, ref, listAll, uploadBytes  ,deleteObject} from 'firebase/storage';
import { Subject, from } from 'rxjs';
import { HelperService } from './helper.service';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private uploadProgressSubject: Subject<number> = new Subject<number>();
  uploadProgress$ = this.uploadProgressSubject.asObservable();
coverImage:any
  constructor(
    private helperService:HelperService,
  ) { }

  getUserFileStorePath(id:any=null) {
    let userId:any
    if(!id)
      userId = getAuth().currentUser?.uid;
    else  userId = id
    // The storage path
    const path = "quiz42/" + userId + "/";
    return path;
  }

  uploadFile(path:any, file:any ) {
    return new Promise((resolve, reject) => {
      // Reference to storage bucket
      const storage = getStorage();
      const imageRef = ref(storage, path);
  
      // The main task
      const uploadTask = uploadBytesResumable(imageRef, file);
      // Progress monitoring
      // percentage = this.task.percentageChanges();
      let imageObj:any = {}
      uploadTask.on('state_changed', (snapshot)=>{
      },function(err){
        console.log(err)
        reject(err)
      },()=>{
        getDownloadURL(imageRef).then((downloadURL) => {
          //Insert image size in the path
          var position = path.lastIndexOf(".")
          imageObj.imageUrl = downloadURL;
          imageObj.resizedImageUrl = [path.slice(0,position),"_200x200",path.slice(position)].join("");
          resolve(imageObj)
        });
      })
    })
  }

  rateLimitEnforce(fileName: any) {
    return new Promise(async (resolve, reject) => {
    let listOfXlsxCreationDate : any = []
    let listOfImgCreationDate : any = []
    var startDate : any;
    let noOfData:any

    let userPath = this.getUserFileStorePath()
    const storage = getStorage();
    const listRef = ref(storage, userPath);
    // get extension of file to get creation date
    let ext = fileName.split(".");
    if(ext[1] == "xlsx"){
      startDate = ext[0]
    }else{
      let currentFileDate = ext[0].split("_")
      startDate = currentFileDate[0]
    }
    // Reference to storage bucket
    await listAll(listRef)
      .then((res) => {
        res.items.forEach((itemRef) => {
          // if file name path contains .xlsx then store data into ...xlsxCreationDate[]
          if(itemRef.name.includes(".xlsx")){
            listOfXlsxCreationDate.push(itemRef.name.split(".xlsx")[0])
            listOfXlsxCreationDate.sort(function(a:any, b:any){return b-a});  //sort in descending order
          }else{
            listOfImgCreationDate.push(itemRef.name.split("_")[0])
            listOfImgCreationDate.sort(function(a:any, b:any){return b-a}); //sort in descending order
          }
        });
      }).catch((error) => {
        console.log("error : ",error)
        // Uh-oh, an error occurred!
      });
      // if extension is xlsx then pass parameter of ..xlsxCreationDate[]
      if(ext[1] == "xlsx")
        noOfData = this.getCountOfFilesPerMin(ext,startDate,listOfXlsxCreationDate)
      else
        noOfData = this.getCountOfFilesPerMin(ext,startDate,listOfImgCreationDate)
 
      // count < limit then sent false to allow to upload files
      if(noOfData.count < noOfData.limit){
        resolve(false)
      }else{
        resolve(true)  // true - to show limit exceeds and show error msg
      }
    })
  }

  getCountOfFilesPerMin(ext:any,startDate:any,listOfCreationDate:any){
    let count = 0;
    let limit;
    startDate = new Date(parseInt(startDate))
   
    if(ext[1] == "xlsx"){
      limit =  5    //upload file not morethan 5 per min
    }else{
      limit =  25   //upload file not morethan 25 per min
    }
      
      for(let i = 0 ; i < limit; i++){
        if(ext[1] == "xlsx"){
          var endDate   = new Date(parseInt(listOfCreationDate[i]));
        }else{
          var endDate   = new Date(parseInt(listOfCreationDate[i]));
        }
        // check currentFile Date and lastuploadedfile date are same or not
        if(startDate.getDate() == endDate.getDate()){
          // var minutes = (startDate.getMinutes() - endDate.getMinutes());
          let time = Math.abs(startDate.getTime() - endDate.getTime()); //getTime of difference b/w both time
          let minutes = Math.floor(time / 60000) //get minutes
          // if minutes is less than 1minute then also check for listOfCreationDate[1],[2],..limit
          if(minutes < 1){
            count++;
            continue
          }else{
            break; //if minutes is 1 then break the loop and return the count 
          }
        }else{
          break;  //if date does not match
        }
      }
    let resObj = {
      count : count,
      limit : limit
    }
    return resObj;
  }



  audioUpload(audio: any, audioName: any, quizId:any=null) {
    return new Promise((resolve, reject) => {
      try {
        if (audio && audioName) {
          const storage = getStorage();
          let storageRef:any 
          let path = this.getUserFileStorePath()
          let uid = this.helperService.uuidv4()
          if(quizId){
              storageRef= ref(storage, `${path}/${quizId}/${audioName}`);
          }else{
            storageRef = ref(storage, `${path}${uid}/${audioName}`);
          }
          const uploadTask = uploadBytesResumable(storageRef, audio);
          uploadTask.on(
            'state_changed',
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

              this.uploadProgressSubject.next(progress);
              // console.log('Upload is ' + progress + '% done');
              switch (snapshot.state) {
                case 'paused':
                  console.log('Upload is paused');
                  break;
                case 'running':
                  console.log('Upload is running');
                  break;
              }
            },
            (_error) => {
              this.uploadProgressSubject.next(-1);
            },
            () => {
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                this.uploadProgressSubject.next(-1);
                resolve(downloadURL)
              });
            }
          );
        }
      } catch (error) {
        console.log("error while uploading audio ", error)
        reject(false)
      }
    })
  }

  // Delete the file from storage
  deleteForStorageData(deleteUrl: any, changeDeleteUrl: any) {
    if (deleteUrl && (changeDeleteUrl?._methodName != undefined) || (changeDeleteUrl && deleteUrl && changeDeleteUrl?._methodName == undefined) ) {
      const storage = getStorage();
      const path = decodeURIComponent(deleteUrl.split("o/")[1]?.split("?")[0]);
      const storageRef = ref(storage, `${path}`);

      if (!changeDeleteUrl?._methodName && (changeDeleteUrl?._methodName != undefined)) {
        let path2 = decodeURIComponent(changeDeleteUrl?.split("o/")[1]?.split("?")[0]);
        console.log('path 2', path2)
        if (path == path2) {
          return;
        }
      }
      // Delete the video file from storage
      deleteObject(storageRef)
        .then(() => {
          console.log(' deleted from storage');
        })
        .catch((error) => {
          console.error('Error deleting  from storage:', error);
        });
    } else {
      console.error('Cannot delete : object or its name is undefined');
    }
  }

  public setCoverImage(v:any){
    this.coverImage=v
  }
  public getCoverImage(){
    return this.coverImage
  }

  uploadQuizFile(userId:any,fileName:any,fileToUpload:any) {
    return new Promise((resolve, reject) => {
      // File path where file will be saved
      const filePath = `quiz42/${userId}/${fileName}`;
      const storage = getStorage();
      const storageRef = ref(storage, filePath);
      // Create a taksk to upload the file
      const uploadTask = uploadBytesResumable(storageRef, fileToUpload);
      uploadTask.on('state_changed', (snapshot) => {
      }, (err) => {
        console.log(err)
      }, async () => {
        // After upload get the download url
        await getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          fileToUpload.url = downloadURL;
          resolve(fileToUpload);
        }).catch((err:any) => {
          reject(err)
        })
      })
    })
  }
}
